import { JoinLeft, JoinRight, JoinInner, JoinOuter, JoinFull } from '@carbon/icons-react';
import * as React from 'react';
export default {
  JoinLeft,
  JoinRight,
  JoinInner,
  JoinOuter,
  JoinFull,
  React
};